<template>
  <tr-card
    card-classes="center-h-and-v no-padding"
    :on-card-click="onAddClick"
  >
    <tr-svg-icon
      name="ic-add-circle"
      size="medium"
      color="green"
    />
    <h2 class="card__title vertical-offset1">
      Adicionar
    </h2>
  </tr-card>
</template>

<script>
import TrCard from './TrCard.vue';
import TrSvgIcon from './TrSvgIcon.vue'

export default {
  name: 'TrAddCard',
  components: {
    TrCard,
    TrSvgIcon
  },
  props: ['onAddClick', 'height']
};
</script>
